// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF"};